import { render } from "./ShareSvg.vue?vue&type=template&id=bd483ada&scoped=true"
import script from "./ShareSvg.vue?vue&type=script&lang=js"
export * from "./ShareSvg.vue?vue&type=script&lang=js"

import "./ShareSvg.vue?vue&type=style&index=0&id=bd483ada&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd483ada"]])

export default __exports__